import {useFetchData} from 'hooks/api/useFetchData'
import {ProcedureCsvExportRequest} from 'types/api/procedureCsvExportRequest/procedureCsvExportRequest'

export const useFetchProcedureCsvRequest = () => {
  const path = '/api/export_procedure_csv_requests/latest'

  return useFetchData<ProcedureCsvExportRequest | undefined>(path, undefined, {})
}
